import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { offer } from '../data/offer';
export function Guarantee() {
  return <section aria-labelledby="garantia-titulo" className="w-full border-t border-line bg-ink py-20 sm:py-24" data-id="element-52" data-mp="1o2vhap4uen6k">
      <div className="mx-auto flex max-w-4xl flex-col gap-6 px-4 sm:flex-row sm:gap-10" data-id="element-53" data-mp="222wk4a4o44oo">
        <ShieldCheckIcon aria-hidden="true" className="h-12 w-12 shrink-0 text-lime" data-id="element-54" data-mp="1x4uz3jnolvak" />
        <div data-id="element-55" data-mp="19fsh2ap4y0fj">
          <h2 id="garantia-titulo" className="font-display text-3xl font-bold uppercase tracking-tight text-bone sm:text-4xl" data-id="element-56" data-mp="19fadet058jxl">
            Garantía «Meta o Reembolso»
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-mute" data-id="element-57" data-mp="1j6n6fnxohg57">
            Probá el plan por {offer.guaranteeDays} días. Si no sentís que tenés más estabilidad y claridad sobre cómo entrenar, mandame un mail y te devuelvo hasta el último centavo.
          </p>
          <p className="mt-4 font-display text-2xl font-bold uppercase text-lime" data-id="element-58" data-mp="lo528r55eftm">
            El riesgo es todo mío.
          </p>
        </div>
      </div>
    </section>;
}